import { useSuspenseQuery } from '@apollo/client';

import type { UnauthorizedJobReason } from '@xing-com/crate-common-graphql-types';
import type { JobTeaserWithHighlightsFragment } from '@xing-com/crate-jobs-graphql';
import { GetJobTeaserDocument } from '@xing-com/crate-jobs-graphql';

import { useVisibleJobTypePolicies } from './use-visible-job-type-policies';

type JobDetailsResponse = {
  job?: JobTeaserWithHighlightsFragment;
  jobId?: string;
  error?: UnauthorizedJobReason;
};

export const useJobTeaser = (slug: string): JobDetailsResponse => {
  useVisibleJobTypePolicies();
  const { data } = useSuspenseQuery(GetJobTeaserDocument, {
    variables: { slug },
    errorPolicy: 'all',
  });

  if (data?.job?.__typename === 'UnauthorizedJob')
    return { error: data.job.reason, jobId: data.job.id };

  const job = data?.job?.__typename === 'VisibleJob' ? data.job : undefined;

  return { job };
};
